import React from "react";

export default function SchemaMarkup() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Orax Solar",
    "description": "Solar installation company in Akola, Maharashtra offering residential, commercial and industrial solar solutions.",
    "image": "https://images.pexels.com/photos/9875685/pexels-photo-9875685.jpeg",
    "@id": "https://www.oraxsolar.com",
    "url": "https://www.oraxsolar.com",
    "telephone": "+919422921481",
    "email": "Info@Oraxsolar.com",
    "priceRange": "₹₹",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Opp. LIC office, Near Tower Chowk, Umri Road",
      "addressLocality": "Akola",
      "addressRegion": "Maharashtra",
      "postalCode": "444001",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 20.7002,
      "longitude": 77.0082
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
      "opens": "09:00",
      "closes": "19:00"
    },
    "areaServed": ["Akola","Amravati","Washim","Buldhana","Yavatmal","Maharashtra"],
    "sameAs": []
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
